import SEOHead from '../components/SEOHead';
import { useLanguage } from '../store/LanguageContext';

export default function CookiePolicyPage() {
  const { lang } = useLanguage();

  return (
    <>
      <SEOHead page="cookiePolicy" />
      <div className="min-h-screen bg-[#faf7f3]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-16 md:py-24">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-8" style={{ fontFamily: 'Playfair Display' }}>
            {lang === 'fr' ? 'Politique de Cookies & Confidentialité' : 'Cookiebeleid & Privacy'}
          </h1>
          <p className="text-sm text-gray-500 mb-8">
            {lang === 'fr' ? 'Dernière mise à jour : 4 mars 2026' : 'Laatst bijgewerkt: 4 maart 2026'}
          </p>

          <div className="prose prose-gray max-w-none space-y-8 text-[#1a1a1a]">
            {lang === 'fr' ? (
              <>
                <section>
                  <h2 className="text-xl font-bold mb-3">1. Responsable du traitement</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Gevelsteenbedrijf.be, dont le siège social est situé à Anvers, Belgique, est responsable du traitement de vos données personnelles. Contact : info@gevelsteenbedrijf.be | +32 (0)3 123 45 67.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">2. Qu'est-ce qu'un cookie ?</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Un cookie est un petit fichier texte placé sur votre appareil lors de votre visite sur notre site web. Les cookies nous permettent de reconnaître votre navigateur et de mémoriser certaines préférences. Conformément au Règlement Général sur la Protection des Données (RGPD) et à la directive ePrivacy, nous demandons votre consentement explicite avant de placer des cookies non essentiels.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">3. Types de cookies utilisés</h2>

                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-4">
                    <div className="bg-green-50 px-4 py-3 border-b border-gray-200">
                      <h3 className="font-semibold text-green-800">Cookies essentiels (toujours actifs)</h3>
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600 space-y-2">
                      <p><strong>gvs-lang</strong> — Mémorise votre préférence linguistique (NL/FR). Durée : permanente.</p>
                      <p><strong>gvs-cookie-consent</strong> — Mémorise votre choix de cookies. Durée : 1 an.</p>
                      <p><strong>gvs-auth</strong> — Session de connexion B2B. Durée : session.</p>
                      <p>Ces cookies sont nécessaires au bon fonctionnement du site et ne requièrent pas de consentement.</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-4">
                    <div className="bg-blue-50 px-4 py-3 border-b border-gray-200">
                      <h3 className="font-semibold text-blue-800">Cookies analytiques (avec consentement)</h3>
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600 space-y-2">
                      <p>Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site. Les données sont anonymisées. Ces cookies ne sont activés qu'après votre consentement explicite.</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <div className="bg-orange-50 px-4 py-3 border-b border-gray-200">
                      <h3 className="font-semibold text-orange-800">Cookies marketing (avec consentement)</h3>
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600 space-y-2">
                      <p>Ces cookies sont utilisés pour afficher des publicités pertinentes. Ils ne sont activés qu'après votre consentement explicite.</p>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">4. Conformité Omnibus Digital et Article 88a AVG</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Conformément aux modifications apportées par la directive Omnibus Digital (EU 2024), nous respectons les nouvelles exigences relatives à la protection des équipements terminaux (article 88a/88b AVG). Notre bannière de cookies est conçue pour éviter la « fatigue du consentement » et offrir un choix clair et transparent. À l'avenir, lorsque les solutions basées sur le navigateur seront disponibles, nous les intégrerons pour simplifier la gestion des cookies.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">5. Vos droits (RGPD)</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Conformément au RGPD, vous disposez des droits suivants : droit d'accès, droit de rectification, droit à l'effacement, droit à la limitation du traitement, droit à la portabilité des données, droit d'opposition. Pour exercer ces droits, contactez-nous à info@gevelsteenbedrijf.be. Vous avez également le droit d'introduire une plainte auprès de l'Autorité de Protection des Données (APD) : www.autoriteprotectiondonnees.be.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">6. Gestion de vos cookies</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Vous pouvez à tout moment modifier vos préférences en matière de cookies en supprimant vos cookies dans les paramètres de votre navigateur, ce qui fera réapparaître notre bannière de cookies lors de votre prochaine visite.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">7. Données collectées via le formulaire de devis</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Lorsque vous demandez un devis, nous collectons : nom, e-mail, téléphone, code postal, et éventuellement le nom de l'entreprise. Ces données sont utilisées exclusivement pour le traitement de votre demande et ne sont jamais partagées avec des tiers à des fins commerciales.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">8. Contact</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Pour toute question relative à notre politique de cookies ou de confidentialité, veuillez nous contacter à info@gevelsteenbedrijf.be ou au +32 (0)3 123 45 67.
                  </p>
                </section>
              </>
            ) : (
              <>
                <section>
                  <h2 className="text-xl font-bold mb-3">1. Verwerkingsverantwoordelijke</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Gevelsteenbedrijf.be, met maatschappelijke zetel te Antwerpen, België, is verantwoordelijk voor de verwerking van uw persoonsgegevens. Contact: info@gevelsteenbedrijf.be | +32 (0)3 123 45 67.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">2. Wat is een cookie?</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Een cookie is een klein tekstbestand dat op uw apparaat wordt geplaatst wanneer u onze website bezoekt. Cookies stellen ons in staat uw browser te herkennen en bepaalde voorkeuren te onthouden. Conform de Algemene Verordening Gegevensbescherming (AVG/GDPR) en de ePrivacy-richtlijn vragen wij uw uitdrukkelijke toestemming voordat niet-essentiële cookies worden geplaatst.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">3. Soorten cookies die wij gebruiken</h2>

                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-4">
                    <div className="bg-green-50 px-4 py-3 border-b border-gray-200">
                      <h3 className="font-semibold text-green-800">Essentiële cookies (altijd actief)</h3>
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600 space-y-2">
                      <p><strong>gvs-lang</strong> — Onthoudt uw taalvoorkeur (NL/FR). Duur: permanent.</p>
                      <p><strong>gvs-cookie-consent</strong> — Onthoudt uw cookiekeuze. Duur: 1 jaar.</p>
                      <p><strong>gvs-auth</strong> — B2B login sessie. Duur: sessie.</p>
                      <p>Deze cookies zijn noodzakelijk voor de goede werking van de website en vereisen geen toestemming.</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mb-4">
                    <div className="bg-blue-50 px-4 py-3 border-b border-gray-200">
                      <h3 className="font-semibold text-blue-800">Analytische cookies (met toestemming)</h3>
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600 space-y-2">
                      <p>Deze cookies helpen ons begrijpen hoe bezoekers onze website gebruiken. De gegevens worden geanonimiseerd. Deze cookies worden enkel geactiveerd na uw uitdrukkelijke toestemming.</p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <div className="bg-orange-50 px-4 py-3 border-b border-gray-200">
                      <h3 className="font-semibold text-orange-800">Marketingcookies (met toestemming)</h3>
                    </div>
                    <div className="px-4 py-3 text-sm text-gray-600 space-y-2">
                      <p>Deze cookies worden gebruikt om relevante advertenties te tonen. Ze worden enkel geactiveerd na uw uitdrukkelijke toestemming.</p>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">4. Conformiteit Digitale Omnibus en Artikel 88a AVG</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Conform de wijzigingen van de Digitale Omnibus-richtlijn (EU 2024) respecteren wij de nieuwe vereisten inzake bescherming van eindapparatuur (artikel 88a/88b AVG). Onze cookiebanner is ontworpen om "consent fatigue" te vermijden en biedt een duidelijke en transparante keuze. In de toekomst zullen wij browsergebaseerde oplossingen integreren wanneer deze beschikbaar komen, om het cookiebeheer te vereenvoudigen.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">5. Uw rechten (AVG/GDPR)</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Conform de AVG/GDPR beschikt u over de volgende rechten: recht op inzage, recht op rectificatie, recht op wissing, recht op beperking van de verwerking, recht op gegevensoverdraagbaarheid, recht van bezwaar. Om deze rechten uit te oefenen kunt u ons contacteren via info@gevelsteenbedrijf.be. U heeft ook het recht een klacht in te dienen bij de Gegevensbeschermingsautoriteit (GBA): www.gegevensbeschermingsautoriteit.be.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">6. Beheer van uw cookies</h2>
                  <p className="text-gray-700 leading-relaxed">
                    U kunt uw cookievoorkeuren op elk moment wijzigen door uw cookies te verwijderen in uw browserinstellingen. Onze cookiebanner verschijnt dan opnieuw bij uw volgende bezoek.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">7. Gegevens verzameld via het offerteformulier</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Wanneer u een offerte aanvraagt, verzamelen wij: naam, e-mail, telefoon, postcode, en eventueel de bedrijfsnaam. Deze gegevens worden uitsluitend gebruikt voor de verwerking van uw aanvraag en worden nooit gedeeld met derden voor commerciële doeleinden.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-bold mb-3">8. Contact</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Voor vragen over ons cookiebeleid of privacybeleid kunt u ons contacteren via info@gevelsteenbedrijf.be of +32 (0)3 123 45 67.
                  </p>
                </section>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
